<template>
  <div class="job-offer__filter-group">
    <div :class="['job-offer__filter-category', {'--opened': isOpen}]" @click="isOpen = !isOpen">
      <h3>{{ title }}</h3>
      <Icon id="drop-arrow"/>
    </div>
    <DropDown :is-open="isOpen">
      <div class="job-offer__filter-list">
        <JobOfferFilter v-for="filter in filteredFilters" :content="filter" :type="type" :key="filter.id"/>
      </div>
    </DropDown>
  </div>
</template>

<script>
import {DropDown, Icon} from '@/components/global'
import {JobOfferFilter} from '@/components/small'

export default {
  name: 'JobOfferFilters',
  components: {DropDown, Icon, JobOfferFilter},
  props: {
    title: {
      type: String,
      required: true
    },
    type: {
      type: String,
      required: true,
      validator: value => ['FIELD_TYPE', 'LOCATION', 'COMPANY'].includes(value)
    }
  },
  data() {
    return {
      isOpen: false
    }
  },
  computed: {
    filteredFilters() {
      const filters = this.$store.state.job[this.apiKey(this.type)]
      return filters.filter(filter => filter.active === 1)
    }
  },
  methods: {
    apiKey(type) {
      return {
        FIELD_TYPE: 'types',
        LOCATION: 'locations',
        COMPANY: 'companies'
      }[type]
    }
  }
}
</script>